export const koKr = {
    '账号密码': '계좌 번호 패스워드',
    '微信验证码': '위챗 인증번호',

    '用户名': '사용자 이름',
    '密码': '암호',
    '登 录': '덩 씨',
    '邮箱验证码': '메일박스 인증 코드',
    '发送': '보내기',
    '绑 定': '묶을',
    '微信二维码': '위챗 2차원 코드',
    '用户名不能为空': '사용자 이름은 비어 있을 수 없습니다',
    '密码不能为空': '密码不能为空',
    '邮箱不能为空': '메일함은 비어 있을 수 없습니다',
    '验证码不能为空': '인증 코드가 비어 있을 수 없습니다',
    '发送成功': '전송이 완료되었습니다.'
}
